export const SITE = {
    name: "Caring for Country",
    domain: "caringforcountry.com.au",
    email: "william@caringforcountry.com.au",
    logo: "https://customer-assets.emergentagent.com/job_country-futures/artifacts/959i3asy_caringforcountry_logo.png",
    icon: "https://customer-assets.emergentagent.com/job_country-futures/artifacts/6f9mpixt_Custom%20dimensions%20450x450%20px%20%282%29.png",
    tagline: "An emerging platform exploring Indigenous-led approaches to land management, restoration, food security, native seed systems, climate resilience and community development.",
    taglineShort: "Healthy Country. Strong communities. Local decision-making. Inseparable.",
};

export const NAV_LINKS = [
    { label: "Why", href: "/#why" },
    { label: "What we do", href: "/#what" },
    { label: "Leadership", href: "/leadership" },
    { label: "Focus", href: "/#focus" },
    { label: "Insights", href: "/insights" },
    { label: "Statement", href: "/#statement" },
    { label: "Contact", href: "/#contact" },
];

export const IMAGES = {
    hero: "https://images.pexels.com/photos/32915384/pexels-photo-32915384.jpeg",
    eucalyptus:
        "https://images.pexels.com/photos/12354525/pexels-photo-12354525.jpeg",
    coast: "https://images.pexels.com/photos/34156949/pexels-photo-34156949.jpeg",
    grasses:
        "https://images.unsplash.com/photo-1765269730897-7f62f80c5830?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxOYXRpdmUlMjBncmFzc2VzJTIwQXVzdHJhbGlhfGVufDB8fHx8MTc4MDU0NDQ5M3ww&ixlib=rb-4.1.0&q=85",
    earth: "https://images.unsplash.com/photo-1614535683569-129faaa108f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxSZWQlMjBlYXJ0aCUyMHRleHR1cmV8ZW58MHx8fHwxNzgwNTQ0NDkzfDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
    {
        n: "01",
        title: "Strategy and Planning",
        body: "Practical Caring for Country strategies, project plans, investment cases and implementation pathways.",
    },
    {
        n: "02",
        title: "Indigenous Land and Sea Management",
        body: "Support for ranger programs, Traditional Owner organisations and land management partners to strengthen governance, delivery and long-term outcomes.",
    },
    {
        n: "03",
        title: "Restoration and Biodiversity",
        body: "Indigenous-led restoration, native seed systems, biodiversity recovery, habitat repair and climate adaptation projects.",
    },
    {
        n: "04",
        title: "Policy and Partnerships",
        body: "Connecting Indigenous priorities with government programs, environmental markets, philanthropic investment and private sector partnerships.",
    },
    {
        n: "05",
        title: "Knowledge and Data Systems",
        body: "Approaches that respect cultural knowledge, data sovereignty, monitoring, reporting and community-controlled information systems.",
    },
    {
        n: "06",
        title: "Economic Development",
        body: "Pathways for Indigenous enterprise in restoration, carbon, biodiversity markets, bush foods, native seed, cultural tourism and land management services.",
    },
];

export const PRINCIPLES = [
    {
        n: "I",
        title: "Country Comes First",
        body: "Healthy Country is the foundation. Every project must respect place, people, culture and ecological function.",
    },
    {
        n: "II",
        title: "Indigenous Leadership",
        body: "Traditional Owners are not stakeholders. They are rights holders, knowledge holders and decision makers.",
    },
    {
        n: "III",
        title: "Long-Term Stewardship",
        body: "Short-term projects are not enough. Caring for Country requires long-term investment, continuity and accountability.",
    },
    {
        n: "IV",
        title: "Cultural Authority",
        body: "Cultural knowledge must not be extracted, diluted or used without permission, governance and benefit returning to communities.",
    },
    {
        n: "V",
        title: "Practical Delivery",
        body: "Strong ideas must become real outcomes on Country — jobs, skills, infrastructure, restoration, monitoring and enterprise.",
    },
    {
        n: "VI",
        title: "Partnership with Respect",
        body: "Good partners listen first, share power, respect data sovereignty and support Indigenous priorities rather than imposing external agendas.",
    },
];

export const FOCUS_AREAS = [
    {
        title: "Indigenous Protected Areas",
        body: "Planning, readiness, governance and long-term management for IPAs and conservation partnerships.",
    },
    {
        title: "Ranger Programs",
        body: "Strengthening ranger capability, training, operations, reporting, partnerships and career pathways.",
    },
    {
        title: "Native Seed & Restoration",
        body: "Indigenous participation in seed collection, banking, propagation, restoration and biodiversity repair.",
    },
    {
        title: "Climate Adaptation",
        body: "Responding to changing seasons, fire, flood, heat, coastal impacts and ecosystem change.",
    },
    {
        title: "Cultural Fire",
        body: "Recognising cultural fire as knowledge, practice and responsibility — not just a land management technique.",
    },
    {
        title: "Biodiversity & Nature Repair",
        body: "Engaging with biodiversity markets, environmental repair and nature-based investment on Indigenous terms.",
    },
    {
        title: "Data Sovereignty",
        body: "Community-controlled monitoring, knowledge systems and data sharing agreements that protect cultural information.",
    },
    {
        title: "Food & Community Resilience",
        body: "Local food systems, orchards, bush foods, community gardens and practical resilience in remote and regional communities.",
    },
];

export const PARTNERS = [
    "Traditional Owner organisations",
    "Indigenous corporations",
    "Ranger groups",
    "Land councils",
    "Government agencies",
    "Philanthropic funders",
    "Environmental organisations",
    "Research institutions",
    "Restoration companies",
    "Corporate and industry partners",
    "Regional communities",
];

export const INTEREST_OPTIONS = [
    "Strategy & planning",
    "Indigenous land & sea management",
    "Restoration & biodiversity",
    "Policy & partnerships",
    "Knowledge & data systems",
    "Economic development",
    "Other",
];
